import {createContext, use, useState, useMemo, type ReactNode} from 'react'
import type {IntentDetectionMode} from '../types/intent-detection-mode'

// This context is used to hold onto the necessary state from copilot immersive
// through the route change to the chat + task specific page.
export type IntentDetectionTaskCreationRequest = {
  nwo: string
  problemStatement: string
  clientGeneratedId: string
  model?: string
  agentId?: string
  customAgent?: string
  baseRef?: string
  createPullRequest?: boolean
  mode?: IntentDetectionMode
}
export interface IntentDetectionContextValue {
  taskCreationRequest: IntentDetectionTaskCreationRequest | null
  setTaskCreationRequest(this: void, request: IntentDetectionTaskCreationRequest | null): void

  mode: IntentDetectionMode
  setMode(this: void, mode: IntentDetectionMode): void
}

// Allow this to be not set up when not required, will disable task creation
export const IntentDetectionContext = createContext<IntentDetectionContextValue>({
  taskCreationRequest: null,
  setTaskCreationRequest: () => {},

  mode: 'task',
  setMode: () => {},
})

interface IntentDetectionProviderProps {
  children: ReactNode
}

export function IntentDetectionProvider({children}: IntentDetectionProviderProps) {
  const [taskCreationRequest, setTaskCreationRequest] = useState<IntentDetectionTaskCreationRequest | null>(null)
  const [mode, setMode] = useState<IntentDetectionMode>('auto')

  const value = useMemo(
    () => ({taskCreationRequest, setTaskCreationRequest, mode, setMode}),
    [taskCreationRequest, setTaskCreationRequest, mode, setMode],
  )

  return <IntentDetectionContext value={value}>{children}</IntentDetectionContext>
}

export function useIntentDetectionContext(): IntentDetectionContextValue {
  return use(IntentDetectionContext)
}
